import { fetchCruiseLineByPageSlug } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector, shallowEqual } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

export function useCruiseLineByPageSlug(pageSlug?: string): [App.CruiseLine | null, boolean] {
  const dispatch = useAppDispatch()

  const {
    cruiseLines,
    fetchingCruiseLines,
  }: {
    cruiseLines: Record<string, App.CruiseLine>
    fetchingCruiseLines: boolean
  } = useAppSelector((state) => ({
    cruiseLines: state.cruise.cruiseLines,
    fetchingCruiseLines: state.cruise.fetchingCruiseLines,
  }), shallowEqual)

  useEffect(() => {
    if (pageSlug) {
      dispatch(fetchCruiseLineByPageSlug(pageSlug))
    }
  }, [pageSlug, dispatch])

  const cruiseLine = useMemo(() => {
    return Object.values(cruiseLines).find((cruiseLine) => cruiseLine.slug === pageSlug) || null
  }, [cruiseLines, pageSlug])

  return [cruiseLine, fetchingCruiseLines]
}
